import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "../QuestionPage/AudioPlayer";

import { useState, useEffect } from "react";
import MockPagination from "./Pagination";
import MockNavigation from "./MockNavigation";

// Fetching Data from the API]

// End

// Page Html
export default function KeyBoardCheckPage() {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [audioLink, setaudioLink] = useState("");

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h1 className="text-2xl pt-3 font-bold text-gray-900 sm:text-3xl ml-1 text-center md:text-start">
          Keyboard Check
        </h1>
        <p className="p-2">
          This is an opportunity to check that you have the correct keyboard.
          <br></br>
          <span>1. Look at the top row of letters on the keyboard.</span>
          <br></br>
          <span>2. The letters should appear in this order Q W E R T Y.</span>
          <br></br>
          <span>
            3. If you do not have a QWERTY keyboard, raise your hand to get the
            attention of the Test Administrator{" "}
          </span>
        </p>
        <img
          className=" absolute  top-12 right-12"
          width="200px"
          src="/image/headphones.jpg"
        ></img>

        <img
          className="p-3"
          width="600px"
          src="/image/keyboard.jpg"
        ></img>
      </div>
    </div>
  );
}
